import React, { FC } from 'react';
import { PulseLoader } from 'react-spinners';
import { Alert } from 'reactstrap';

import { formatISODate } from '../../helpers/formatISODate';
import useTranslate from '../../hooks/useTranslate';
import { AccommodationItemType, AccommodationType } from '../../services/apis/accommodation/types';
import AccommodationDatesPicker from '../AccommodationDatesPicker/AccommodationDatesPicker';
import AccommodationItem from '../AccommodationItem/AccommodationItem';
import AccommodationInfo from './AccommodationInfo';

export interface AccommodationProps {
  loading: boolean;
  accommodation: AccommodationType;
  accommodationItems?: AccommodationItemType[];
  checkinDate: string;
  checkoutDate: string;
  onDateChange: ([checkinDate, checkoutDate]: [string, string]) => void;
}

const Accommodation: FC<AccommodationProps> = props => {
  const { loading, accommodation, accommodationItems, checkinDate, checkoutDate, onDateChange } =
    props;

  const { translate } = useTranslate();
  const availableAccommodationItems = accommodationItems?.filter(item => item.available) ?? [];
  const notAvailableAccommodationItems = accommodationItems?.filter(item => !item.available) ?? [];

  return (
    <>
      <h1>{String(translate('accommodation.accommodationBooking'))}</h1>
      <h2 className="h3 mb-3">{accommodation.name}</h2>
      <AccommodationInfo accommodation={accommodation} />
      <h3 className="h2">{String(translate('accommodation.availability'))}</h3>
      <AccommodationDatesPicker
        className="mb-4"
        startDate={checkinDate ? new Date(`${checkinDate}T00:00:00`) : undefined}
        endDate={checkoutDate ? new Date(`${checkoutDate}T00:00:00`) : undefined}
        onChange={([startDate, endDate]) =>
          onDateChange([formatISODate(startDate), formatISODate(endDate)])
        }
      />
      {accommodationItems && accommodationItems.length > 0 ? (
        <div className="d-flex flex-column gap-4 mb-5">
          {[...availableAccommodationItems, ...notAvailableAccommodationItems].map(item => (
            <AccommodationItem
              // force re-render to reset component's internal state
              // key={`${item.id}_${checkinDate}_${checkoutDate}`}
              key={item.id}
              item={item}
              disabled={loading}
              accommodationId={accommodation.id}
              checkinDate={checkinDate}
              checkoutDate={checkoutDate}
            />
          ))}
        </div>
      ) : loading ? (
        <div className="text-center">
          <PulseLoader color="currentColor" />
        </div>
      ) : (
        <Alert color="info">{String(translate('accommodation.notAvailableForDates'))}</Alert>
      )}
    </>
  );
};

export default Accommodation;
